import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickFromRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M254.625 56h-38.632L16 256.2L216 456h38.623V336h144V176h-144Zm112 152v96h-144v113.384l-161.37-161.21l161.37-161.535V208Zm96-152h32v400h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickFromRight
